import React, { Fragment, useState } from "react";
import { ReactComponent as BlueCalendarTimeIcon } from "../../assets/images/blueCalendarTimeIcon.svg";
import { DayPilotNavigator } from "@daypilot/daypilot-lite-react";
import SubTaskIcon from "../Icons/SubTaskIcon";
import useInitialLetters from "../../hooks/LetterShow/useInitialLetters";
import { Tooltip } from "@mui/material";
import useDateWithDay from "../../hooks/DateFormatter/useDateWithDay";
import { useFetchTaskGetOrgAccordingQuery } from "../../utils/customer/customerTaskTable";
import { useParams } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import AvatarName from "../UniversalComponents/AvatarName";

const formatDate = (dateString) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const date = new Date(dateString.split(" ")[0]);
  return date.toLocaleDateString("en-GB", options);
};
const CalenderEvent = ({ setView, view, setStartDate, startDate }) => {
  const { id: customerId } = useParams();
  const { token } = useRequireAuth();

  const { data: taskRecurrenceAll, refetch: taskRecurrenceFetch } = useFetchTaskGetOrgAccordingQuery({
    token,
    customerId: customerId,
  });
  const [showCalendar, setShowCalendar] = useState(false);
  const [showEvents, setShowEvents] = useState(true);

  const [events, setEvents] = useState([]);
  const [eventSearchQuery, setEventSearchQuery] = useState("");

  const { getInitials } = useInitialLetters();
  const [eventsSearch, setEventsSearch] = useState(false);
  const [filteredAllDayTasks, setFilteredAllDayTasks] = useState([]);
  const [modalOpen, setModalOpen] = useState(null);

  const filteredTasks = filteredAllDayTasks.filter(
    (event) =>
      event.text?.toLowerCase().includes(eventSearchQuery?.toLowerCase()) ||
      (event.priority && event.priority?.toLowerCase().includes(eventSearchQuery?.toLowerCase())) ||
      (event.owner && event.owner?.toLowerCase().includes(eventSearchQuery?.toLowerCase()))
  );
  const AllTaskEventsEdit = (alleventedit) => {
    const matchedTask = taskRecurrenceAll?.data?.find((task) =>
      alleventedit.parent_task_id ? task.id === alleventedit.parent_task_id : task.id === alleventedit.id
    );

    setModalOpen(matchedTask);
  };
  const CalendarOpenNow = () => {
    setShowCalendar(!showCalendar);
  };

  const formattedStartDate = useDateWithDay(new Date(startDate?.value));
  const AllEventSearch = () => {
    setEventsSearch(!eventsSearch);
  };
  const AllEventsExpand = () => {
    setShowEvents(!showEvents);
  };
  return (
    <div className="ms-3 w-[320px]">
      <button
        className="bg-DCEEF8 mb-2 rounded-t-md flex  justify-between items-center p-1 w-full"
        type="button"
        onClick={() => {
          CalendarOpenNow();
        }}
      >
        <div className="flex items-center">
          <div>
            <BlueCalendarTimeIcon />
          </div>

          {/* <div className="mx-2 font-medium text-2C495D">{formattedStartDate}</div> */}
          <div className="mx-2 font-medium text-2C495D">24-1-2025</div>
        </div>

        <span className="mx-2">
          <i className={`bi bi-chevron-${showCalendar ? "up" : "down"} text-535252`}></i>
        </span>
      </button>
      {true && (
        <div className="flex justify-center mb-2">
          <DayPilotNavigator
            selectMode={"Month"}
            showMonths={1}
            skipMonths={1}
            weekStarts={1}
            onTimeRangeSelected={(args) => setStartDate(args.day)}
            events={events}
            //   theme="navigator_custom_new"
            //   style={{ width: "500px" }}
          />
        </div>
      )}

      {true && (
        <Fragment>
          <div className="bg-DCEEF8 border-b border-[#1D44691A] rounded-t-md py-1 px-3 flex justify-between items-center">
            <div className="text-2C495D font-medium">All Events</div>

            <div>
              <button
                type="button"
                className="px-2 py-1 rounded bg-B9D6E5"
                onClick={() => {
                  AllEventSearch();
                }}
              >
                <i class="bi bi-search text-white"></i>
              </button>
              <button
                type="button"
                className="ms-1"
                onClick={() => {
                  AllEventsExpand();
                }}
              >
                {" "}
                <i className={`bi bi-chevron-${showEvents ? "up" : "down"} text-535252`}></i>{" "}
              </button>
            </div>
          </div>

          {true && (
            <div className="border py-2 px-4 overflow-y-auto h-[35vh]">
              {eventsSearch && (
                <input
                  type="search"
                  className="rounded bg-white border border-1D446933 mb-3"
                  value={eventSearchQuery}
                  onChange={(e) => setEventSearchQuery(e.target.value)}
                />
              )}

              <div>
                {filteredTasks && filteredTasks.length > 0 ? (
                  <Fragment>
                    {/* Sort tasks by start date */}
                    {Object.entries(
                      filteredTasks
                        .sort((a, b) => new Date(a.start_date) - new Date(b.start_date)) // Sort tasks by start date in ascending order
                        .reduce((acc, event) => {
                          const dateKey = formatDate(event.start_date); // Group by formatted start date
                          if (!acc[dateKey]) acc[dateKey] = []; // If date doesn't exist, create an array
                          acc[dateKey].push(event); // Push the event into the array for that date
                          return acc;
                        }, {})
                    ).map(([date, tasks], index) => (
                      <Fragment key={index}>
                        {/* Display the formatted date at the top of the first card for each group */}
                        <span>{date}</span>
                        {tasks.map((event, taskIndex) => (
                          <Fragment key={taskIndex}>
                            <div className="mb-2">
                              <div
                                className={`p-2 border ${event?.parent_task_id ? "bg-E1E6EC text-black" : "bg-284356 text-white"}   text-xs rounded`}
                                onClick={() => {
                                  AllTaskEventsEdit(event);
                                }}
                              >
                                <div className="flex">
                                  <div className="w-[30px] h-[24px] bg-white rounded-full flex justify-center items-center mr-2">
                                    <p className="text-black font-500">
                                      <Tooltip
                                        title={event?.parent_task_id ? "Sub Task" : event?.priority}
                                        placement="left"
                                        arrow
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              bgcolor: "common.white",
                                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                              color: "#383838",
                                              "& .MuiTooltip-arrow": {
                                                color: "common.white",
                                                filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                              },
                                            },
                                          },
                                        }}
                                      >
                                        {event?.parent_task_id ? (
                                          <span>
                                            <SubTaskIcon />
                                          </span>
                                        ) : (
                                          event.priority[0]
                                        )}
                                      </Tooltip>
                                    </p>
                                  </div>
                                  <div className="w-full mb-1 capitalize bg-[#FFFFFF33] py-1 px-3 rounded">
                                    {event.text}
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <i className="bi bi-calendar-week me-1 text-lg mr-2"></i>{" "}
                                  {formatDate(event.start_date)} - {formatDate(event.end_date)}
                                </div>
                                <div className="mb-3">
                                  <div className="flex">
                                    {event?.assigned_to?.slice(0, 3).map((person, i) => (
                                      <Fragment>
                                        <i className="bi bi-person-plus me-1 text-lg mr-2"></i>

                                        <Tooltip key={i} title={person.name} arrow>
                                          <div className="w-[25px] h-[25px flex justify-center items-center mr-2">
                                            <AvatarName
                                              name={getInitials(person.name)}
                                              size="medium"
                                              bgColor={"#ffffff"}
                                              textColor={"#000000"}
                                              // borderColor={"#AAC9DB"}
                                            />
                                          </div>
                                        </Tooltip>
                                      </Fragment>
                                    ))}
                                    {/* If more than 3, show +X icon */}
                                    {event?.assigned_to?.length > 3 && (
                                      <Tooltip title={`${event.assigned_to.length - 3} more`} arrow>
                                        <div className="w-[30px] h-[30px] bg-gray-300 text-black rounded-full flex justify-center items-center">
                                          +{event.assigned_to.length - 3}
                                        </div>
                                      </Tooltip>
                                    )}
                                  </div>
                                </div>
                                <div className="my-2 mt-6">
                                  <span className="px-2 py-1 border border-[#00000033] bg-[#00000033] rounded">
                                    {event.status}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
                  </Fragment>
                ) : (
                  <div className="text-center text-gray-500">No All Day Events</div>
                )}
              </div>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default CalenderEvent;
